import { render, staticRenderFns } from "./ClassDetail.vue?vue&type=template&id=76af9170&scoped=true"
import script from "./ClassDetail.vue?vue&type=script&lang=js"
export * from "./ClassDetail.vue?vue&type=script&lang=js"
import style0 from "./ClassDetail.vue?vue&type=style&index=0&id=76af9170&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76af9170",
  null
  
)

export default component.exports